/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Box from '@cashew/box';
import Button from '@cashew/button';
import List from '@cashew/list';
import Title from '@cashew/title';
import ListItem from '@cashew/list-item';
import Pagination from '@cashew/pagination';
import cn from 'classnames';
import OrdersFilter from './OrdersFilter';
import './index.css';

const ns = 'refunds';

export default ({
  t,
  useSelector,
  history,
  isOffline = false,
  type = '',
}: any) => {
  const dispatch = useDispatch();
  const [list, setList] = useState<Array<any> | undefined>(undefined);
  const [pageNumber, setPageNumber] = useState(0);
  const [records, setRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [isData, setIsData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  return (
    <div className={ns}>
      <Title>
        <span>{t('refunds.title')}</span>
        <span>
          <Button
            extraClass="blue show-filter-btn"
            onClick={() => setShowFilter(!showFilter)}
          >
            <div className="btn-with-icon">
              <img src="/fillter.svg" alt="filter" />
              Filters
            </div>
          </Button>
        </span>
      </Title>
      <div className={cn({ 'hide-filter': !showFilter })}>
        <OrdersFilter
          setLoading={setLoading}
          useSelector={useSelector}
          type={type}
          setRecords={setRecords}
          setList={setList}
          pageSize={pageSize}
          pageNumber={pageNumber}
          history={history}
          dispatch={dispatch}
          isListEmpty={!isData}
          setIsData={setIsData}
          isData={isData}
          setPageNumber={setPageNumber}
          records={records}
        />
      </div>
      <div style={{ height: '16px' }} />
      <Box withHeader>
        <>
          <div className={`${ns}__headers`}>
            <p>Refund ID</p>
            <p>Refund date</p>
            {(isOffline || type === 'cashew') && <p>Merchant order code</p>}
            <p>Store name</p>
            <p>Refund Status</p>
            <p>Total amount</p>
          </div>
          <List
            data={list}
            component={ListItem}
            context="refunds"
            isLoading={loading}
            t={t}
            isOffline={isOffline || type === 'cashew'}
          />
          <Pagination
            records={records}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            changePageSize={setPageSize}
          />
        </>
      </Box>
    </div>
  );
};
